import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from './FoldersListItem.css';
import { AddStroke16 } from '@cian/ui-kit';

interface IProps {
  onClick(): void;
}

export function FoldersListItemNew({ onClick }: IProps) {
  return (
    <div {...mergeStyles(styles['container'], styles['container-new-item'])} onClick={onClick}>
      <div className={styles['image']}>
        <AddStroke16 color="primary_100" />
      </div>
      <div className={styles['title']}>Новая подборка</div>
    </div>
  );
}
